
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import ScreenCanvas from "@/components/stead/store/screens/ScreenCanvas.vue";
import { lightToHeavy, StepLightDocument } from "@/models/step.model";
import { InstructionDocument } from "@/models/instruction.model";
import { ParamValueDocument } from "@/models/parameter.model";

@Component({
  components: {ScreenCanvas}
})
export default class RehearsalDialog extends Vue {
  // Les props
  @PropSync('show') private isVisible!: boolean
  @Prop() private tcid!: string

  // Les propriétés
  private loading: boolean = false
  private stop: boolean = false
  private stepId: number = 0
  private boxH: number = 0

  // Les propriétés calculées
  private get TcDoc() {
    return this.$store.state.testcase.testcase
  }

  private get steps(): StepLightDocument[] {
    return this.$store.state.step.steps
  }

  private get max() {
    return this.steps.length
  }

  private get loadingSteps(): boolean {
    return this.$store.state.step.shotloading
  }

  private get stepDoc() {
    if (this.steps.length && this.stepId >= 0 && this.stepId < this.steps.length) {
      return lightToHeavy(this.steps[this.stepId])
    } else {
      return null
    }
  }

  private get urlShot() {
    if (this.stepDoc && this.stepDoc.tobject) {
      return this.$store.getters['step/shotUrl'](this.stepDoc.tobject.screenshot)
    } else {
      return ''
    }
  }

  private get stepInstruc(): InstructionDocument {
    return this.$store.getters['forge/instruction'](this.stepDoc ? this.stepDoc.instruc : '')
  }

  private get stepParams(): ParamValueDocument[] {
    return this.$store.getters['forge/intrucParams'](this.stepInstruc._id, this.stepDoc ? this.stepDoc.parameters : [])
  }

  // Les hooks
  // Les méthodes surveillées
  @Watch('tcid')
  private async loadTestcase() {
    const alreadyLoadedTC = this.$store.state.testcase.testcase
    const alreadyLoadedSteps = this.$store.state.step.tcid
    if (alreadyLoadedTC && alreadyLoadedTC._id === alreadyLoadedSteps){
      // Les données sont déjà chargées
    } else {
      this.loading = true
      await Promise.all([
        this.$store.dispatch('step/getTestcaseSteps', this.tcid),
        this.$store.dispatch('testcase/getTestcase', this.tcid)
      ])
      this.loading = false
    }
  }

  @Watch('isVisible')
  private onShow() {
    if (this.isVisible) {
      window.onkeydown = this.onKeydown
      this.loadTestcase()
      this.stop = true
      this.stepId = -1
      window.addEventListener('resize', this.listener)
    } else {
      this.stop = true
      window.onkeydown = null
      window.removeEventListener('resize', this.listener)
    }
  }

  @Watch('step')
  private onChangeStep() {
    this.listener()
  }

  // Les méthodes d'instance
  private onKeydown(ev: KeyboardEvent) {
    // console.log('onKeydown ', ev.key)
    ev.preventDefault()
    switch (ev.key) {
      case ' ' :
        // console.log(`space stop=${this.stop}`)
        this.stop = !this.stop
        this.run()
        break
      case 'ArrowUp':
        if (this.stop && this.stepId > -1) {
          this.stepId -= 1
        }
        break
      case 'ArrowDown':
        if (this.stop && this.stepId < this.steps.length) {
          this.stepId += 1
        }
        break
    }
  }

  private run() {
    // console.log(`run stop=${this.stop} step=${this.step}`)
    if (!this.stop) {
      this.stepId += 1
      if (this.stepDoc) {
        setTimeout(this.run, 1000)
      } else {
        this.stop = true
      }
    }
  }

  private listener() {
    // console.log('resize ', ev)
    const box = document.getElementById('box') as HTMLDivElement
    if (box) {
      // console.log(`box h=${box.clientHeight}, w=${box.clientWidth}`)
      this.boxH = box.clientHeight
    } else {
      this.boxH = 0
    }

  }

  // Les méthodes statiques
  private colorText = (checking: boolean) => {
    return `color: ${checking ? 'green' : 'steelblue'}`
  }
}

